import { Link } from 'react-router-dom';
import { buttonVariants } from '@/components/design-system/button';
import { cn } from '@/utils/index';

export const NotFoundPage = () => {
  return (
    <section className="flex flex-1 items-center justify-center py-16">
      <div className="flex max-w-xl flex-col items-center gap-6 text-center">
        <p className="text-6xl font-bold uppercase tracking-widest text-foreground">
          404
        </p>

        <div className="space-y-3">
          <h1 className="text-3xl font-bold tracking-tight text-muted-foreground sm:text-4xl">
            Page not found
          </h1>
          <p className="text-base text-muted-foreground">
            The page you are looking for may have been moved, renamed, or might
            never have existed.
          </p>
        </div>

        <Link
          to="/"
          className={cn(buttonVariants({ variant: 'default', size: 'lg' }))}
        >
          Back to home
        </Link>
      </div>
    </section>
  );
};
